import React from 'react';
import DateFilter from './DateFilter';
import {makeWhere} from '../More/Actions/BookWorkspace/whereUtil';

export default class BookingDateFilter extends React.Component {
  constructor(props) {
    super(props);
  }

  optionClicked = (type, menuOptions, dateSelected) => {
    const criteria = {
      dateOption: menuOptions.props.value,
      dateSelected: dateSelected
    }
    // We will use this object to filter Office 365 reservations
    const filterDataChanges = {}
    const where = makeWhere(criteria, filterDataChanges);
    
    const data = {
      where: where,
      criteria: criteria,
      dateStart: filterDataChanges.dtStart,
      dateEnd: filterDataChanges.dtEnd
    };
    
    if (this.props.onFilterChange) {
      this.props.onFilterChange(data);
    }
  }
  
  render() {
    return (
      <span style={{justifyContent: 'flex-end'}} className='i-events-options'>
        <DateFilter onClick={this.optionClicked} type={this.props.type} 
          isOffice365={this.props.isOffice365}/>
      </span>
    )
  }
}